const api = '/api/v1/m002_r_code_controller.php';
import axios from 'axios';
export const code_repository =  {
    get(data){
        return  axios.get(api,data);
    },
    upd(data){
        return  axios.post(api, data);
    }
};

